const getFriendsReducer = (state = { friendsState: [] }, action) => {
    switch (action.type) {
        case "GET_FRIENDS":
            return {
                friendsState: action.friendsState
            }

        default:
            return state;
    }
}

export default getFriendsReducer;


// WEBPACK FOOTER //
// ./src/reducer/getfriendsreducer.jsx